/* eslint-disable no-tabs */
// import http from '@/helpers/http'
import { fireApp, Timestamp } from '@/helpers/_firebase'
export default {
  name: 'download',
  components: {},
  props: [],
  data () {
    return {}
  },
  computed: {},
  mounted () {
    if (this.$route.name === 'landing') {
      this.influencers()
    }
    if (this.$route.name === 'landing-no-param') {
      if (navigator.userAgent.match(/Android/i)) {
        window.location.replace('https://play.google.com/store/apps/details?id=io.devsigners.bpx_app')
      }

      if (navigator.userAgent.match(/iPhone|iPad|iPod/i)) {
        window.location.replace('https://apps.apple.com/us/app/bpx-app/id1465664254?l=es&ls=1')
      }
    }
    // FUNCIONAMIENTO PARA MAPS
    if (this.$route.name === 'maps') {
      this.mapa()
    }

    // if (navigator.userAgent.match(/Mozilla/i)) {
    //   window.location.replace('https://play.google.com/store/apps/details?id=io.devsigners.bpx_app')
    // }
  },
  methods: {
    async mapa () {
      var latDestino = this.$route.params.lat_destino
      var lngDestino = this.$route.params.lng_destino
      var latInicio = this.$route.params.lat_inicio
      var lngInicio = this.$route.params.lng_inicio
      // var hashDestino = 'kYv5w2Xn'
      var hashDestino = this.$route.params.hash_destino
      // var hashInicio = 'NX2WW32w'
      var hashInicio = this.$route.params.hash_inicio

      // let arr = []
      // const date = Timestamp.now()
      // const log = arr.push(date)
      let check = await fireApp
        .firestore()
        .collection('directorio')
        .doc(hashDestino)
        .collection('consultas')
        .doc(hashInicio)
        .get()

      console.log('check ', check)

      if (!check.exists) {
        await fireApp
          .firestore()
          .collection('directorio')
          .doc(hashDestino)
          .collection('consultas')
          .doc(hashInicio)
          .set({ log: [] })

        let some = await fireApp
          .firestore()
          .collection('directorio')
          .doc(hashDestino)
          .collection('consultas')
          .doc(hashInicio)
          .get()

        let res = some.data()
        console.log('res: ', res.log.push(Timestamp.now()))

        await fireApp
          .firestore()
          .collection('directorio')
          .doc(hashDestino)
          .collection('consultas')
          .doc(hashInicio)
          .set(res)
          .then(
            res => {
              window.location.replace(
                'https://www.google.com/maps/dir/' +
									latInicio +
									',' +
									lngInicio +
									'/' +
									latDestino +
									',' +
									lngDestino
              )
            },
            err => {
              console.table(err)
            }
          )
      } else {
        let some = await fireApp
          .firestore()
          .collection('directorio')
          .doc(hashDestino)
          .collection('consultas')
          .doc(hashInicio)
          .get()

        let res = some.data()
        console.log('res: ', res.log.push(Timestamp.now()))

        await fireApp
          .firestore()
          .collection('directorio')
          .doc(hashDestino)
          .collection('consultas')
          .doc(hashInicio)
          .set(res)
          .then(
            res => {
              window.location.replace(
                'https://www.google.com/maps/dir/' +
									latInicio +
									',' +
									lngInicio +
									'/' +
									latDestino +
									',' +
									lngDestino
              )
            },
            err => {
              console.table(err)
            }
          )
      }
    },
    async influencers () {
      let some = await fireApp
        .firestore()
        .collection('influencers')
        .doc(this.$route.params.influencer)
        .get()

      let res = some.data()
      // let res = some.data()['link'].push(Timestamp.now())
      console.log('res: ', res.link.push(Timestamp.now()))
      await fireApp
        .firestore()
        .collection('influencers')
        .doc(this.$route.params.influencer)
        .set(res)
        .then(
          res => {
            // FUNCIONAMIENTO PARA LANDING DE INFLUENCERS
            if (navigator.userAgent.match(/Android/i)) {
              window.location.replace(
                'https://play.google.com/store/apps/details?id=io.devsigners.bpx_app'
              )
            }

            if (navigator.userAgent.match(/iPhone|iPad|iPod/i)) {
              window.location.replace('https://apps.apple.com/us/app/bpx-app/id1465664254?l=es&ls=1')
            }
          },
          err => {
            console.table(err)
          }
        )
    }
  }
}
